import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import config from 'config/default.json';
@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent {
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    public sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private apiService: ApiServiceModule,
    private helper: HelperModule,
    public dialog: MatDialog
    ) {}

  PDFJS = (window as { [key: string]: any })["pdfjs-dist/build/pdf"];
  @Input() pageOrigin!: string;
  @Input() pdfData!: { [key: string]: any };
  @Input() userInfos!: { [key: string]: any };
  @Output() callBackEvent = new EventEmitter<any>();
  @ViewChild('pdf_container') container!: ElementRef;
  isBuilt:boolean = false;
  zoomControl = new FormControl(1);
  globalZoom: number = 1; 
  renderedPages: any[] = [];
  fileUrls: any[] = [];

  batchSize = 10; 
  navIndex = 0;
  totalNavigations = 0;
  splitPages:Set<number> = new Set<number>();

  ngOnInit(){

  }
  ngAfterViewInit() {
    if (this.container?.nativeElement && this.pdfData && this.pdfData['contents']) {
      this.container.nativeElement.style.height = this.pdfData['height']? `${this.pdfData['height']}px`: '100%';
      if (!this.pdfData['refresh']) {
        Promise.resolve().then(() => {
          console.log('Build 1')
          this.initNavigation();
        });
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pdfData'] && !changes['pdfData'].firstChange) {
      this.container.nativeElement.style.height = this.pdfData['height']? `${this.pdfData['height']}px`: '100%';
      console.log('Build 2')
      this.initNavigation();
    }
  }
  initNavigation() {
    this.navIndex = 0;
    this.totalNavigations = Math.ceil(this.pdfData['contents'].length / this.batchSize);
    this.reloadBatch(); 
  }
  get currentBatch(): string[] {
    const start = this.navIndex * this.batchSize;
    return this.pdfData['contents'].slice(start, start + this.batchSize);
  }

  movePrevNavigation() {
    if (this.navIndex > 0) {
      this.navIndex--;
      this.reloadBatch();
    }
  }

  moveNextNavigation() {
    if (this.navIndex < this.totalNavigations - 1) {
      this.navIndex++;
      this.reloadBatch();
    }
  }
  
  reloadBatch(){
    if(this.pdfData['source'] == 'service'){
      let filesPath:any = {}
      this.currentBatch.forEach((raw:any)=> filesPath[raw.id_content] = raw.url);
      let data = {
        table: 'generate_files_urls',
        files_path: filesPath
      }
      const formData = new FormData();
      formData.append('data', JSON.stringify(data));
      this.apiService.queryData(config.service.cloud.url + '/generate_files_urls', formData, this.userInfos['access_token']).subscribe(async(response:any)=>{
        
        this.fileUrls = this.currentBatch.map((element: any) => ({id_content: element.id_content, url: response[element.id_content].file_url}));
        this.showPages();
      })
    }else{
      this.fileUrls = this.pdfData['contents'];
      this.showPages();
    } 
  }
  removeChildsFromElement(element:any){
    while (element.hasChildNodes()) {
      element.removeChild(element.lastChild);
    }
  }
  async showPages() {
    this.PDFJS.GlobalWorkerOptions.workerSrc = 'assets/pdf/pdf.worker.js';
    this.renderedPages = [];
    this.removeChildsFromElement(this.container.nativeElement);
    let that = this;
    
    for (let index = 0; index < this.fileUrls.length; index++) {
      let rowInfos = this.fileUrls[index];

      try {
        const pdf = await this.PDFJS.getDocument(rowInfos['url']).promise;
        let totalPages = pdf.numPages;
        let totalPagesShow = totalPages;
        that.splitPages.add(0);
        that.splitPages.add(totalPages);
        if(this.pageOrigin == 'add-content-spliting') totalPages = 1;

        for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {

          const page = await pdf.getPage(pageNumber);
          const viewport = page.getViewport({ scale: this.globalZoom });
          const originalViewport = page.getViewport({ scale: 1 });

          const canvas = this.renderer.createElement('canvas');
          const context = canvas.getContext('2d');

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          // Header container
          const canvasDivContainer = this.renderer.createElement('div');
          canvasDivContainer.classList.add("canvasDivContainer");

          const canvasDiv = this.renderer.createElement('div');
          canvasDiv.classList.add("canvasDiv");
          canvasDiv.style.width = viewport.width + 'px';

          // Page header and separator
          const header = this.renderer.createElement('div');
          header.classList.add("page_header");

          const leftSide = this.renderer.createElement('div');
          const middleSide = this.renderer.createElement('div');
          const rightSide = this.renderer.createElement('div');
          const separator = this.renderer.createElement('div');
          const dividerDiv = this.renderer.createElement("div");

          middleSide.textContent = `Content: ${rowInfos['id_content']} - Total pages: ${totalPagesShow}`;
          leftSide.classList.add("page_header_left");
          middleSide.classList.add("page_header_middle");
          rightSide.classList.add("page_header_right");
          separator.classList.add("text_page_number");
          separator.textContent = `Page: ${pageNumber}`;

          if(this.pageOrigin == 'add-content-spliting'){
            let addIcon = this.renderer.createElement('mat-icon');
            addIcon = this.iconProperties(addIcon, 'add', 'Add Content');
            addIcon.addEventListener('click', function(e:any) {
              that.callBackEvent.emit(rowInfos['id_content']);
            });
            rightSide.appendChild(addIcon)
          }
          if(this.pageOrigin == 'project_creation'){
            dividerDiv.classList.add("divider-container");

            let dividerIcon = this.renderer.createElement('mat-icon');
            dividerIcon = this.iconProperties(dividerIcon, 'content_cut', 'Cut', "#1591EA");
            dividerIcon.style.zIndex = "10";
            
            let line = this.renderer.createElement("div");
            line.classList.add("line_separator");
            dividerIcon.addEventListener('click', function(e:any) {
              if (that.splitPages.has(pageNumber)) {
                line.style.borderTop = "none";
                that.splitPages.delete(pageNumber); 
              } else {
                line.style.borderTop = "3px dashed #1591EA";
                that.splitPages.add(pageNumber); 
              }
              const splitPagesList: number[] = [...that.splitPages].sort((a:any, b:any) => a - b);
              console.log(splitPagesList)
              that.callBackEvent.emit({id_content: rowInfos['id_content'], split_pages: that.splitPages.size > 2? splitPagesList.slice(1).map((v:number, i:number) => [splitPagesList[i], v]): null});

            });
            dividerDiv.append(dividerIcon, line);
          }
          // Render initial
          await page.render({canvasContext: context, viewport: viewport}).promise;

          header.append(leftSide, middleSide, rightSide);
          if (pageNumber === 1) canvasDiv.append(header, canvas, separator, dividerDiv);
          if(pageNumber == totalPages) canvasDiv.append(canvas, separator);
          else canvasDiv.append(canvas, separator, dividerDiv);
          

          canvasDivContainer.appendChild(canvasDiv);
          this.container.nativeElement.appendChild(canvasDivContainer);
          // Save page for re-render zoom
          this.renderedPages.push({page, canvas, originalViewport, canvasDiv, renderTask: null });
        }

      } catch (error) {
        console.error(error);
      }
    }
    this.zoomControl.valueChanges.subscribe((value:any) => {
      this.applyGlobalZoom(value);
    });
  }
  
  async applyGlobalZoom(value: number) {
    this.globalZoom = value;

    for (let item of this.renderedPages) {

      // cancel ongoing render
      if (item.renderTask) {
        try { item.renderTask.cancel(); } catch (e) {}
      }

      const viewport = item.originalViewport.clone({ scale: this.globalZoom });

      const canvas = item.canvas;
      const context = canvas.getContext('2d');

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      item.canvasDiv.style.width  = viewport.width + 'px';

      // create a new render task
      item.renderTask = item.page.render({
        canvasContext: context,
        viewport
      });

      try {
        await item.renderTask.promise;
      } catch (err) {
        // ignore cancellations
      }
    }
  }
  iconProperties(icon:any, iconName:string, title:string, color = "white"){
    let attributes = {
      fonticon: iconName,
      title: title,
      'ng-reflect-font-icon': iconName,
      'data-mat-icon-type': 'font',
      'data-mat-icon-name': iconName,
      'aria-hidden': 'false'
    }
    for (const [key, value] of Object.entries(attributes)) {
      icon.setAttribute(key, value);
    }
    icon.style.color = color;
    icon.classList.add("bx", "bx-menu", "page_icons", 'mat-icon','notranslate','material-icons','mat-ligature-font','mat-icon-no-color');
    return icon
  }

}
